import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20luxurious%20Chinese%20red%20and%20gold%20abstract%20geometric%20pattern%20background%20with%20soft%20flowing%20ribbons%20and%20sparkling%20light%20particles%2C%20elegant%20gradient%20texture%2C%20festive%20atmosphere%2C%20premium%20dark%20background%20with%20subtle%20glowing%20accents%2C%20sophisticated%20gaming%20entertainment%20aesthetic&width=1920&height=800&seq=hero-bg-2026&orientation=landscape"
          alt="注册送彩金活动背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
          <i className="ri-fire-line text-primary-400"></i>
          <span className="text-primary-300 text-sm font-medium">活动火热进行中 · 名额有限先到先得</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-5 leading-tight">
          {heroData.title}
        </h1>
        <p className="text-xl md:text-2xl text-background-100 font-heading mb-4">
          {heroData.subtitle}
        </p>
        <p className="max-w-2xl mx-auto text-base md:text-lg text-foreground-200 leading-relaxed mb-8">
          {heroData.description}
        </p>

        <div className="flex flex-col items-center gap-4">
          <a
            href="#"
            className="px-8 py-4 bg-primary-500 text-background-50 rounded-xl text-lg font-bold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105"
          >
            {heroData.ctaText}
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <p className="text-foreground-300 text-sm">
            <i className="ri-user-line mr-1"></i>
            {heroData.ctaSubtext}
          </p>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          <div className="flex items-center gap-2 text-foreground-200 text-sm">
            <i className="ri-shield-check-line text-accent-400 text-lg"></i>
            <span>安全保障</span>
          </div>
          <div className="flex items-center gap-2 text-foreground-200 text-sm">
            <i className="ri-flashlight-line text-accent-400 text-lg"></i>
            <span>秒级到账</span>
          </div>
          <div className="flex items-center gap-2 text-foreground-200 text-sm">
            <i className="ri-smartphone-line text-accent-400 text-lg"></i>
            <span>多端畅玩</span>
          </div>
          <div className="flex items-center gap-2 text-foreground-200 text-sm">
            <i className="ri-customer-service-2-line text-accent-400 text-lg"></i>
            <span>24h客服</span>
          </div>
        </div>
      </div>
    </section>
  );
}